
import {urlConfig} from '@/api/urlConfig';
import {promptMessage,fetch,baseUrl} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import {formatTel} from '../../../static/js/tel';
export default {
data(){
return{
tkshow:false,
submitdisabled:false,
contentTxt:'',
btnShow:true,
sureTxt:'',
tkcontentTxt:''
}
},
components: {
XButton,Alert
},
computed: {
handledContentTxt:function(){
return  formatTel(this.contentTxt.replace(/\n/g, "<br/>"))
}
},
methods: {
tkHide(){
window.location.href = this.wxInfoUrl;
},
getData () {
if (this.openid && this.btnShow){  //如果需要确认
this.getUserId();
fetch('post', baseUrl + '/app/' + this.messageId + '/queryConfirmMessageInfoById').then(response => {
this.contentTxt = response.MSGCONTENT;
if (response.CONFIRMPERSON == 'null' || response.CONFIRMPERSON == null) {
this.submitdisabled = false;
this.sureTxt = '请确认';
} else {
this.submitdisabled = true;
this.sureTxt = '已确认';
}
this.$store.commit('updateLoadingStatus', {isLoading: false});
}).catch(error => {

})
}else{ //如果不需要确认
fetch('post','/app/' + this.messageId + '/queryMessageById').then(response => {
let content ='';
if(response.contentDx){
content = response.contentDx
}else{
content = response.content;
}
console.log(response.wxInfoUrl,55555,response)
if(response.wxInfoUrl){  //有链接跳转
this.wxInfoUrl = response.wxInfoUrl
this.tkcontentTxt = '<div style="text-align: justify;min-height: 50vh;padding-top: 15px;">'+content+'</div>';
this.tkshow = true;
}else{
this.contentTxt = content;
}

this.$store.commit('updateLoadingStatus',{isLoading:false})
}).catch(error => {

})
}

},
getUserId(){
fetch('get',urlConfig.GetSfzh + '?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
}).catch(error => {

})

},
submit(){
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('post',baseUrl+'/app/updateConfirmPerson?confirmPersonId='+this.personInfoId+'&messageId='+this.messageId).then(response => {
this.submitdisabled = true;
this.sureTxt = '已确认';
this.$store.commit('updateLoadingStatus',{isLoading:false});
promptMessage('提示','确认成功！');
}).catch(error => {
this.submitdisabled = false;
})
}
},
mounted(){
document.title = 'JXR武汉锦欣中西医结合妇产医院';
this.$store.commit('updateLoadingStatus',{isLoading:true});
getken(this.getData);
this.messageId = this.$route.query.messageId;
this.isneedConfirm = this.$route.query.isneedConfirm;
this.openid = this.$route.query.openid;
if(this.isneedConfirm && this.isneedConfirm.toString() == 'true'){
this.btnShow = true;
}else {
this.btnShow = false;
}
}
}



// WEBPACK FOOTER //
// ./src/project/newDetailProject/newDetail.vue